window.addEventListener('load', function() {
    var productHandle = localStorage.getItem('currentProduct');
    var url = new URL(window.location.href);
    var params = url.searchParams;
    var token = params.get('token');
    var settingId = params.get('setting_id');

    if(token != null && settingId != null){
        localStorage.setItem(settingId, decodeURIComponent(token));
    }

    var route_url = localStorage.getItem('tci_route_url');

    if(productHandle != null && token !== null){
        if(route_url == '/'){
            location.href='https://' + url.host + route_url + 'products/' + productHandle;
        } else {
            location.href='https://' + url.host + route_url + '/products/' + productHandle;
        }
    } else if(!Shopify.designMode) {
           location.href='https://' + url.host;
    }
})
